module.exports = "<a href=\"/api/v3/notifications/\" target=\"_self\">\n    <img class=\"bell\" ng-src=\"/assets/images/bell-ico.png\" />\n    <span\n        class=\"number\"\n        ng-if=\"NotificationsBellCtrl.countElements && NotificationsBellCtrl.countElements <= 99\"\n        >{{ NotificationsBellCtrl.countElements }}</span\n    >\n    <span\n        class=\"number small\"\n        ng-if=\"NotificationsBellCtrl.countElements && NotificationsBellCtrl.countElements > 99\"\n        >99+</span\n    >\n</a>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/notifications/bell/notifications-bell.html
// module id = 692
// module chunks = 0